'use strict';

/*******************************************************************************
 Helper functions to setup the payment method select in payment forms
*******************************************************************************/

const CREDIT_CARD_PAYMENT_METHOD_ID = 6;

class PaymentMethodFormHelper {

	constructor(form) {
		this.form = form;
		this.initialized = false;
	}

	checkElements() {
		console.log(this.form.find('#company-id, #payment-method-id, #credit-card-inputs'));

		if (this.form.find('#company-id, #payment-method-id, #credit-card-inputs').length !== 3) {
			throw 'Missing inputs or invalid input IDs';
		}
	}

	initialize() {
		$('#credit-card-inputs').hide();

		this.companyChange();
		this.paymentChange();

		$('#company-id').trigger('change');

		this.initialized = true;
	}

	companyChange() {
		this.form.on('change', '#company-id', (event) => {
			let companyId = $(event.target).val();

			$.ajax({
				method: 'POST',
				url: waApp.getLanguage() + '/payment-methods',
				dataType: 'json',
				data: {
					company_id: companyId
				}
			}).done((data) => {
				let paymentMethodId = $('#payment-method-id');

				paymentMethodId.html('');

				$.each(data.paymentMethods, (key, value) => {
					paymentMethodId.append('<option value=' + key + '>' + value + '</option>');
				});

				paymentMethodId.trigger('change');
			});
		});
	}

	paymentChange() {
		this.form.on('change', '#payment-method-id', (event) => {
			let value = $(event.target).val();

			if (value == CREDIT_CARD_PAYMENT_METHOD_ID) {
				$('#credit-card-inputs').fadeIn('slow');
			} else {
				$('#credit-card-inputs').fadeOut('fast');
			}
		});
	}

}
